/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Button, InputGroup, Row, Col,
} from 'reactstrap';

import {
  Field, FormikConsumer, ErrorMessage,
} from 'formik';

function AttributesFieldset(props) {
  const { arrayHelpers, t } = props;

  const handleAddAttribute = () => {
    arrayHelpers.push({
      label: '',
      code: '',
    });
  };

  const jsx = (
    <FormikConsumer>
      {({
        // eslint-disable-next-line no-unused-vars
        touched, errors, values, setFieldValue,
      }) => (
        <div>
          <Button color="info" onClick={() => handleAddAttribute(arrayHelpers)} className="btn-sm btn-soft-info mt-3 mb-3">
            <span className="bx bx-plus" />
            {props.t('Add Attribute')}
          </Button>
          {values.attributes.map((attribute, index) => (
            <div key={index}>
              <Row className="mt-4">
                <Col xs="6">
                  <InputGroup>
                    <Button
                      type="button"
                      onClick={() => arrayHelpers.remove(index)}
                      color="danger"
                      className="btn-soft-danger"
                    >
                      <span className="mdi mdi-close-thick" />
                    </Button>
                    <Field name={`attributes[${index}].label`} type="text" className="form-control" placeholder={t('Label')} />
                    <Button
                      type="button"
                      onClick={(e) => {
                        // eslint-disable-next-line eqeqeq
                        setFieldValue(`attributes[${index}].required`, (values.attributes[index].required == false));
                        e.target.blur();
                      }}
                      color={values.attributes[index].required ? 'danger' : 'light'}
                      title={`${values.attributes[index].required ? t('Required') : t('Not required')}`}
                    >
                      <span className={`mdi mdi-star ${values.attributes[index].required ? 'mdi-spin' : ''}`} />
                    </Button>
                  </InputGroup>
                  <ErrorMessage
                    name={`attributes[${index}].label`}
                    component="div"
                    className="text-danger pt-1"
                  />
                </Col>

                <Col xs="6">
                  <Field name={`attributes[${index}].code`} type="text" className="form-control" placeholder={t('Pre-set Value')} />
                  <ErrorMessage
                    name={`attributes[${index}].code`}
                    component="div"
                    className="text-danger pt-1"
                  />
                </Col>
              </Row>
              <Row className="mb-4 mt-2">
                <Col xs="6">
                  <Field name={`attributes[${index}].pattern`} type="text" className="form-control" placeholder={t('Pattern')} />
                  <ErrorMessage
                    name={`attributes[${index}].pattern`}
                    component="div"
                    className="text-danger pt-1"
                  />
                </Col>

                <Col xs="6">
                  <Field name={`attributes[${index}].message`} type="text" className="form-control" placeholder={t('Error Message')} />
                  <ErrorMessage
                    name={`attributes[${index}].message`}
                    component="div"
                    className="text-danger pt-1"
                  />
                </Col>
              </Row>
            </div>
          ))}
        </div>
      )}
    </FormikConsumer>
  );

  return jsx;
}

AttributesFieldset.defaultProps = {
  t: (x) => (x),
};

AttributesFieldset.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  arrayHelpers: PropTypes.object.isRequired,
};

export default connect(() => ({

}), {})(withTranslation()(AttributesFieldset));
